import { useEffect } from "react";
import { DateTime } from 'luxon';
import { ContentArticle } from './types';
import { Avatar, AvatarImage } from '@playcastdotio/Shadcn';

interface ArticleProps {
  article: ContentArticle;
}

export const Article = (props: ArticleProps) => {
  const { article } = props;

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [article]);

  return (
    <div className='bg-content text-content-text m-0 h-auto w-full p-0'>
      <div className='bg-hero bg-content text-content-text m-0 h-auto w-full bg-cover bg-no-repeat p-0'>
        <div className='container mx-auto h-auto w-full max-w-[1024px] px-0 pb-8 pt-4 md:pt-20'>
          <div className='[&>h2]:text-primary mx-8 flex flex-col gap-10 md:mx-14 md:gap-8 [&>h2]:text-2xl [&>h2]:font-bold'>
            <section id='hero' className='grid grid-cols-12 gap-x-8 gap-y-8'>
              <div className='col-span-12 flex flex-col gap-4 md:col-span-6'>
                <div>
                  <p className='text-sm'>
                    <time dateTime={article.published}>{DateTime.fromISO(article.published).toFormat('dd LLL yyyy')}</time>
                  </p>
                  <h1 className='text-3xl font-bold'>{article.title}</h1>
                </div>
                <p>{article.summary}</p>
                <div className='flex flex-row gap-2'>
                  <Avatar className='h-12 w-12'>
                    <AvatarImage src={article.author.headshot} alt={article.author.name} />
                  </Avatar>
                  <div className='ml-2'>
                    <p className='text-lg font-bold'>{article.author.name}</p>
                    <p className='-mt-1 italic'>{article.author.title}</p>
                  </div>
                </div>
              </div>
              <div className='col-span-full md:col-span-6'>
                <img src={article.banner} alt={article.title} className='aspect-[3/2] h-auto w-full object-cover' />
              </div>
            </section>
          </div>
        </div>
      </div>

      <div className='bg-content-secondary text-content-text m-0 h-auto w-full'>
        <div className='container mx-auto h-auto w-full max-w-[1024px] px-0 py-8'>
          <div className='[&>h2]:text-primary mx-8 flex flex-col gap-10 md:mx-14 md:gap-8 [&>h2]:text-2xl [&>h2]:font-bold'>
            {article.body}
          </div>
        </div>
      </div>

      <div className='bg-content-secondary text-content-text m-0 h-auto w-full'>
        <div className='container mx-auto h-auto w-full max-w-[1024px] px-0 py-8'>
          <div className='[&>h2]:text-primary mx-8 flex flex-col gap-10 md:mx-14 md:gap-4 [&>h2]:text-2xl [&>h2]:font-bold'>
            <h2>About the Author</h2>
            <div className='flex items-center gap-2'>
              <Avatar className='h-12 w-12'>
                <AvatarImage src={article.author.headshot} alt={article.author.name} />
              </Avatar>
              <div className='ml-2'>
                <p className='text-lg font-bold'>{article.author.name}</p>
                <p className='-mt-1 italic'>{article.author.title}</p>
              </div>
            </div>
            <div className=''>{article.author.bio}</div>
            </div>
        </div>
      </div>
    </div>
  );
};
